import { render, staticRenderFns } from "./role-attach-menu-modal.vue?vue&type=template&id=11e6ee48&"
import script from "./role-attach-menu-modal.vue?vue&type=script&lang=js&"
export * from "./role-attach-menu-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports